import { useI18n } from 'vue-i18n'

export function useStatusLabels() {
  const { t, te } = useI18n()
  function label(group, status, fallback) {
    const key = `statusLabels.${group}.${status}`
    return te(key) ? t(key) : (fallback || t('common.unknown'))
  }
  return {
    projectStatusLabel: (status, fallback) => label('projects', status, fallback),
    transferStatusLabel: (status, fallback) => label('transfers', status, fallback),
    transferLineStatusLabel: (status, fallback) => label('transferLines', status, fallback),
    signingStatusLabel: (status, fallback) => label('signing', status, fallback),
  }
}
